import React from "react";
import GetAge from "../../Utils/GetAge";
function ChildQuestion(props) {
  let idNo = props.id;
  const logging = false;
  function getAge() {
    // console.log("today", `${mm},${dd}, ${yyyy}`);
    var DOBdd = 0;
    var DOBmm = 0;
    var DOByyyy = 0;
    var ageThisYear = 0;
    getChildAnswer("DoB_1");
    if (
      getChildAnswer("DoB_1") &&
      getChildAnswer("DoB_2") &&
      getChildAnswer("DoB_3")
    ) {
      DOBdd = getChildAnswer("DoB_2");
      DOBmm = getChildAnswer("DoB_1");
      DOByyyy = getChildAnswer("DoB_3");
      if (logging === true) console.log("DoB", `${DOBmm},${DOBdd}, ${DOByyyy}`);

      ageThisYear = GetAge(DOBdd, DOBmm, DOByyyy);
    } else {
      if (logging === true) console.log("No DOB Answer");
      return "";
    }

    // console.log("DoB", `${DOBmm},${DOBdd}, ${DOByyyy}`);
    return ageThisYear;
  }
  function getChildAnswer(val) {
    let QID = "Child_" + idNo + "_" + val;
    let rv = props.getAnswer(QID, 0);
    return rv;
  }
  return (
    <div id={"Child_" + idNo + "_Container"}>
      <label className="description" htmlFor={"Child_" + idNo + "_Name"}>
        Child name and Date of Birth{" "}
      </label>
      <span>
        <input
          id={"Child_" + idNo + "_Name_1"}
          type="text"
          name={"Child_" + idNo + "_Name_1"}
          className="element text"
          maxLength="255"
          size="8"
          defaultValue={getChildAnswer("Name_1")}
          onBlur={(event) => {
            props.handleValue(event);
          }}
          required
        />
        <label>First</label>
      </span>
      <span>
        <input
          id={"Child_" + idNo + "_Name_2"}
          type="text"
          name={"Child_" + idNo + "_Name_2"}
          className="element text"
          maxLength="255"
          defaultValue={getChildAnswer("Name_2")}
          size="12"
          onBlur={(event) => {
            props.handleValue(event);
          }}
        />
        <label>Last</label>
      </span>
      <span>
        <input
          id={"Child_" + idNo + "_DoB_1"}
          name={"Child_" + idNo + "_DoB_1"}
          defaultValue={getChildAnswer("DoB_1")}
          className="element text"
          size="2"
          maxLength="2"
          onBlur={(event) => {
            props.handleValue(event);
          }}
          type="text"
          required
        />
        <label htmlFor={"Child_" + idNo + "_DoB_1"}>MM</label>
      </span>
      <span>
        <input
          id={"Child_" + idNo + "_DoB_2"}
          defaultValue={getChildAnswer("DoB_2")}
          name={"Child_" + idNo + "_DoB_2"}
          className="element text"
          size="2"
          maxLength="2"
          onBlur={(event) => {
            props.handleValue(event);
          }}
          type="text"
          required
        />
        <label htmlFor={"Child_" + idNo + "_DoB_2"}>DD</label>
      </span>
      <span>
        <input
          id={"Child_" + idNo + "_DoB_3"}
          name={"Child_" + idNo + "_DoB_3"}
          defaultValue={getChildAnswer("DoB_3")}
          className="element text"
          size="4"
          maxLength="4"
          onBlur={(event) => {
            props.handleValue(event);
          }}
          type="text"
          required
        />
        <label htmlFor={"Child_" + idNo + "_DoB_3"}>YYYY</label>
      </span>
      <span>
        {getAge() !== undefined && getAge() !== "" ? "Age: " + getAge() : ""}
      </span>
    </div>
  );
}

export default ChildQuestion;
